import React from "react";
import InputError from "./InputError";

import "css/SimpleFormField.css";

const SimpleFormField = ({ children, type = "text", input, meta, ...otherProps }) => {
    let style = {};
    if (type === "checkbox") {
        style.display = "inline-block";
    }

    let elements = [];
    elements.push(<input key="input" type={type} {...otherProps} {...input} />);

    if (type === "checkbox") {
        elements.push(<span key="dummy-checkbox" className="dummy-checkbox" />);
        if (children)
            elements.push(
                <span key="label" className="field-label">
                    {children}
                </span>
            );
    } else {
        if (children)
            elements.unshift(
                <span key="label" className="field-label">
                    {children}
                </span>
            );
    }

    return (
        <label className="SimpleFormField" style={style}>
            {elements}

            <InputError metas={meta} />
        </label>
    );
};

export default SimpleFormField;



// WEBPACK FOOTER //
// ./src/components/SimpleFormField.js